// Only an explicit false completes without the existing OTP challenge.
// Auto Debit and Client Portal use the initiation result directly.
export const completeWorldpayAccessWithout3ds = (result, failureMessage) => {
    if (result?.status !== 1) {
        throw new Error(failureMessage);
    }
    return result?.data?.is3ds === false;
};
